import React from 'react';
import { ArrowLeft, MessageSquare, Sparkles, Quote } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
interface ChatHeaderProps {
  title: string | null;
  quote: string | null;
  taskId: string;
}
export function ChatHeader({
  title,
  quote,
  taskId
}: ChatHeaderProps) {
  return <div className="bg-background border-b border-border/40 sticky top-0 z-10" data-id="element-75">
      <div className="max-w-3xl mx-auto px-4 py-3" data-id="element-76">
        <div className="flex items-center gap-3 mb-2" data-id="element-77">
          <Link to={`/v/${taskId}`} data-id="element-78">
            <Button variant="ghost" size="icon" className="h-8 w-8 -ml-2" data-id="element-79">
              <ArrowLeft size={18} data-id="element-80" />
            </Button>
          </Link>
          <div className="flex-1 min-w-0" data-id="element-81">
            <h1 className="font-semibold text-base truncate flex items-center gap-2" data-id="element-82">
              <MessageSquare size={16} className="text-primary flex-shrink-0" data-id="element-83" />
              {title || 'Untitled Transcript'}
            </h1>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground bg-primary/10 px-2 py-1 rounded-full flex-shrink-0" data-id="element-84">
            <Sparkles size={12} className="text-primary" data-id="element-85" />
            <span data-id="element-86">AI Chat</span>
          </div>
        </div>

        {quote && <div className="bg-secondary/30 rounded-lg p-3 text-sm text-muted-foreground flex gap-3 items-start" data-id="element-87">
            <Quote size={14} className="text-primary mt-1 flex-shrink-0" data-id="element-88" />
            <p className="line-clamp-2 italic" data-id="element-89">{quote}</p>
          </div>}
      </div>
    </div>;
}